export const S3_COMPATIBLE_REPOSITORY_TYPE = {
  OVH: "ovh",
  SECUNET: "secunet"
};
export const STORAGE_REPOSITORY_TYPE = {
  GCS: "gcs",
  S3: "s3",
  FS: "fs",
  HDFS: "hdfs",
  ABS: "azure",
  ...S3_COMPATIBLE_REPOSITORY_TYPE
};
export const STORAGE_REPOSITORY_TYPE_LABELS = {
  s3: "Amazon S3",
  gcs: "Google Cloud Storage",
  fs: "File System",
  hdfs: "Hadoop Distributed File System",
  azure: "Azure Blob Storage",
  ovh: "OVH Object Storage",
  secunet: "Secunet S3 Storage"
};
export const resolveRepositoryType = (type) => type === S3_COMPATIBLE_REPOSITORY_TYPE.OVH || type === S3_COMPATIBLE_REPOSITORY_TYPE.SECUNET ? STORAGE_REPOSITORY_TYPE.S3 : type;
export const S3_AUTH_MODE = {
  AUTOMATIC: "automatic",
  KEY_SECRET: "key_secret"
};
